import { useEffect, useMemo } from "react";
import { MapContainer, TileLayer, Marker, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useTheme } from "../context/ThemeContext";

const OSM_URL = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

function makeIcon(index, active) {
  return L.divIcon({
    className: "",
    html: `<div class="night-marker ${active ? "active" : ""}">${index + 1}</div>`,
    iconSize: [38, 38],
    iconAnchor: [19, 19],
  });
}

function FitBounds({ points }) {
  const map = useMap();
  useEffect(() => {
    if (!points.length) return;
    if (points.length === 1) {
      map.setView(points[0], 15);
    } else {
      map.fitBounds(points, { padding: [60, 60], maxZoom: 16 });
    }
  }, [points, map]);
  return null;
}

export function ItineraryMap({ stops, center, activeIndex }) {
  const { theme } = useTheme();
  const points = useMemo(
    () => stops.filter((s) => s.lat && s.lon).map((s) => [s.lat, s.lon]),
    [stops]
  );
  const initial = points[0] || [center?.lat || 0, center?.lon || 0];

  return (
    <MapContainer
      center={initial}
      zoom={14}
      scrollWheelZoom
      className={theme === "dark" ? "map-dark" : "map-light"}
      style={{ height: "100%", width: "100%" }}
      data-testid="itinerary-map"
    >
      <TileLayer url={OSM_URL} attribution="&copy; OpenStreetMap contributors" />
      {points.length > 1 && (
        <Polyline
          positions={points}
          pathOptions={{ color: "#D946EF", weight: 3, opacity: 0.85, dashArray: "1 8", lineCap: "round" }}
        />
      )}
      {stops
        .filter((s) => s.lat && s.lon)
        .map((s, i) => (
          <Marker key={`${i}-${activeIndex === i}`} position={[s.lat, s.lon]} icon={makeIcon(i, activeIndex === i)} />
        ))}
      <FitBounds points={points} />
    </MapContainer>
  );
}
